import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import api from '@/api'

@Module({ namespaced: true })
class ModelIdeas extends VuexModule {
  public inspirationIdeas: Array<any> = []
  public fetchedList = false
  private fetchedProductCode = ''

  @Mutation
  public saveList (payload: {data: Array<any>; productCode: string}): void {
    this.fetchedList = true
    this.inspirationIdeas = payload.data
    this.fetchedProductCode = payload.productCode
  }

  @Action
  public loadModelIdeas (productCode: string): Promise<boolean> {
    if (this.fetchedList && this.fetchedProductCode === productCode) {
      return Promise.resolve(true)
    } else {
      return api
        .get('/products/' + productCode + '/ideas/')
        .then(response => {
          this.context.commit('saveList', { data: response.data, productCode })
          return true
        })
        .catch(() => {
          return false
        })
    }
  }
}
export default ModelIdeas
